<template>
  <!-- <pre v-if="responseData"> testData={{ url }}</pre> -->
  <div v-if="responseData">
    <div class="content-wrapper">
      <h2>Dengue Fever Information Center (DFIC)</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedEpid"
            label="Minggu Epid"
            :items="epidWeeks"
            placeholder="Pilih Epid"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>Kes Demam Denggi</h2>
      <div class="table-container flex-container">
        <!-- Minggu Epid Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Minggu Epid
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  {{ selectedEpid }}
                </td>
              </tr>
              <tr>
                <th>Bilangan Kes</th>
                <th>Kematian</th>
              </tr>
              <tr>
                <td>{{ epidWeek.bilangan_kes ?? 0 }}</td>
                <td>{{ epidWeek.bilangan_kes_kematian ?? 0 }}</td>
                <!--
                  <td>{{ numberWithCommas(epidWeek.bilangan_kes) ?? 0 }}</td>
                  <td>{{ numberWithCommas(epidWeek.bilangan_kes_kematian) ?? 0 }}</td> 
                -->
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Kumulatif Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Kumulatif
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  1 - {{ selectedEpid }}
                </td>
              </tr>
              <tr>
                <th>Bilangan Kes</th>
                <th>Kematian</th>
              </tr>
              <tr>
                <td>{{ epidWeek.kumulatif_kes ?? 0 }}</td>
                <td>{{ epidWeek.kumulatif_kematian ?? 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="chart-wrapper">
        <Lines
          :chart-title="demamTitle"
          :chart-legend="demamLegend"
          :chart-categories="demamCategories"
          :chart-data="demamData"
        />
      </div>
      <h2>Hotspot</h2>
      <div class="table-container flex-container">
        <!-- Minggu Epid Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Minggu Epid
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  {{ selectedEpid ?? 0 }}
                </td>
              </tr>
              <tr>
                <th>Bilangan Hotspot</th>
                <th>Bilangan PBT</th>
              </tr>
              <tr>
                <td>{{ epidWeek.bilangan_hotspot ?? 0 }}</td>
                <td>{{ epidWeek.bilangan_pbt_terlibat ?? 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Kumulatif Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Kumulatif
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  1 - {{ selectedEpid }}
                </td>
              </tr>
              <tr>
                <th>Kumulatif Bilangan Hotspot</th>
                <th>Bilangan PBT Terlibat</th>
              </tr>
              <tr>
                <td>{{ epidWeek.kumulatif_bilangan_hotspot ?? 0 }}</td>
                <td>{{ epidWeek.kumulatif_bilangan_pbt_terlibat ?? 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      
      <div class="chart-wrapper">
        <Lines
          :chart-title="chartTitle"
          :chart-legend="chartLegend"
          :chart-categories="chartCategories"
          :chart-data="chartData"
        />
      </div>
    </div>
    <PrimaryModule />
    <KesihatanPersekitaran />
  </div>
</template>



<script setup>
import Lines from "@/components/chart/Lines.vue"
import { useHttpService } from "@/httpService"
import { ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const demamTitle = ref('Demam Denggi')
const demamLegend = ref(['Bilangan Kes', 'Kematian'])

const demamData = ref([
  { name: 'Bilangan Kes', data: [] },
  { name: 'Kematian', data: [] },
])

const demamCategories = ref([])

const chartTitle = ref('Hotspot')
const chartLegend = ref(['Bilangan Hotspot', 'Bilangan PBT'])

const chartData = ref([
  { name: 'Bilangan Hotspot', data: [] },
  { name: 'Bilangan PBT', data: [] },
])

const chartCategories = ref([])


const years = ref([])
const states = ref(["Semua Negeri"])
const councils = ref([])
const selectedYear = ref(2023)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')
const epidWeeks = ref([])
const selectedEpid = ref(53)
const epidWeek = ref({})

const { httpGet } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(epid = selectedEpid.value, year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}&epid=${epid}`

    if (!plainStates.includes("Semua Negeri")) {

      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {

      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    const url = `kesihatan-persekitaran/vektor/dengi-dfic?year=${selectedYear.value}&epid_week=${selectedEpid.value}${queryParams}`
    const response = await httpGet(url)

    epidWeeks.value = response.epid_weeks
    years.value = response.years
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    epidWeek.value = responseData.value.data.data

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

async function loadDataFromApiYear(year = selectedYear.value, state = selectedsState.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    const categories = Array.from({ length: 53 }, (_, i) => i + 1) 


    const urls = categories.map(
      week => `kesihatan-persekitaran/vektor/dengi-dfic?year=${year}&epid_week=${week}${queryParams}`,
    )


    const responses = await Promise.all(urls.map(url => httpGet(url)))


    const caseData = new Array(53).fill(0)
    const kematianData = new Array(53).fill(0)
    const hotspotData = new Array(53).fill(0)
    const pbtData = new Array(53).fill(0)


    responses.forEach((response, index) => {
      if (response && response.data && response.data.data) {
        const data = response.data.data

        caseData[index] = Number(data.bilangan_kes || 0) 
        kematianData[index] = Number(data.bilangan_kes_kematian || 0) 
        hotspotData[index] = Number(data.bilangan_hotspot || 0) 
        pbtData[index] = Number(data.bilangan_pbt_terlibat || 0)
      } else {
        console.warn(`No valid data for week ${index + 1}`)
      }
    })

 
    demamData.value = [
      { name: "Bilangan Kes", data: caseData },
      { name: "Kematian", data: kematianData },
    ]

    chartData.value = [
      { name: "Bilangan Hotspot", data: hotspotData },
      { name: "Bilangan PBT", data: pbtData },
    ]

    demamCategories.value = categories 
    chartCategories.value = categories

  } catch (err) {
    console.error("loadDataFromApiYear failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState is an array
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (state) {
        pbt.value.push(...councils.value[state].map(council => council.value))
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state]) {
        console.log('Adding councils for state:', state, councils[state])
        pbt.value.push(...councils.value[state].map(council => council.value))
      } else {
        console.warn(`No councils found for state: ${state}`)
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}


onMounted(() => {
  loadDataFromApi()
  loadDataFromApiYear()
})

watch([selectedEpid, selectedYear, selectedsState], () => {
  loadDataFromApi(selectedEpid.value, selectedYear.value, selectedsState.value)
}, { immediate: true })

watch([selectedYear, selectedsState], () => {
  loadDataFromApiYear(selectedYear.value, selectedsState.value)
})
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; 
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); 
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}



h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}

.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}



.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}

.table-container.flex-container {
  display: flex;
  justify-content: space-between;
  gap: 20px; 
  width: 100%;
}


.table-container.small {
  flex: 1;
  max-width: 48%; 
}


.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  text-align: center;
}

.total-row {
  background-color: white;
  font-weight: bold;
  text-align: center;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
}

.status-table td {
  color: #000;
  padding: 12px;
}

.status-table th,
.status-table td {
  border: 1px solid #ddd;
  padding: 12px;
}
</style>
